/* eslint-disable react/prop-types */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { get, map } from "lodash/fp.js";
import { ProductData } from "../types/index.js";
import { MobileHeader } from "./styles.js";
import { CustomAccordion } from "../../reusableComponents/CustomAccordion/index.js";
import { ProductsMobileHeader } from "./productsMobileHeader/index.js";
import ProductsDetails from "./productsDetails.js";

function ProductsTableMobile({ data }) {
  const createSID = (prodID, siteID) => {
    return prodID.toString() + "-" + siteID.toString();
  };

  const productRows = useMemo(
    () =>
      map((item) => ({
        ...item,
        sid: createSID(item.productId, item.siteId),
      }))(data),
    [JSON.stringify(data)]
  );

  return (
    <>
      <MobileHeader>Product Name</MobileHeader>
      <CustomAccordion
        elements={productRows}
        keyGetter={get("sid")}
        headerComponent={ProductsMobileHeader}
        contentComponent={ProductsDetails}
      />
    </>
  );
}

ProductsTableMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(ProductData)).isRequired,
};

export default ProductsTableMobile;
